import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useCompaniesUpdate = createUseMutationHook(
    'update_company',
    () => [
        'get_companies_list',
    ],
);
